import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';

import { DemandReviewListPage } from './DemandReviewListPage';
import { DemandReviewWorkspace } from './DemandReviewWorkspace';

/**
 * Routes for the Document Review (Demand Review) feature.
 * - /document-review → List of all demand review workspaces
 * - /document-review/:workspaceId → Individual workspace view
 */
export const DemandReviewRoutes: React.FC = () => {
  const { matterId } = useMatter();

  return (
    <Routes>
      <Route path="/" element={<DemandReviewListPage matterId={matterId} />} />
      <Route
        path="/:workspaceId"
        element={<DemandReviewWorkspaceWrapper matterId={matterId} />}
      />
    </Routes>
  );
};

const DemandReviewWorkspaceWrapper: React.FC<{ matterId: string }> = ({
  matterId,
}) => {
  const { workspaceId } = useParams<{ workspaceId: string }>();

  if (!workspaceId) {
    return <div>Workspace ID is required</div>;
  }

  return (
    <DemandReviewWorkspace matterId={matterId} workspaceId={workspaceId} />
  );
};

export default DemandReviewRoutes;
